export const environment = {
  production: false,
  hasIam: true,
  apiPlaces: 'https://places.temrango.com.br',
  apiUsers: 'https://users.temrango.com.br',
  apiOrders: 'https://orders.temrango.com.br',
  apiDomains: 'https://domains.temrango.com.br',
  apiZero1BitIam: 'https://zero1bit-iam.temrango.com.br',
  apmServer: 'https://apm.temrango.com.br',
  firebase: {
    apiKey: 'AIzaSyCKgrabmSWWVlBxA5HIxGvIjCaW9IAHmo0',
    authDomain: 'temango-bd354.firebaseapp.com',
    projectId: 'temango-bd354',
    storageBucket: 'temango-bd354.firebasestorage.app',
    messagingSenderId: '708943228223',
    appId: '1:708943228223:web:bb454dbcdbde02ba25378a',
    measurementId: 'G-SFXNCTRRXP',
    vapidKey:
      'BJBSH9d-8x5Sj01VuZtG7BhrX2QPFWKDD5ZYDATnx6kVgrhvwSDMcMBQezVOtZF3wTUTQ0gZX30jdcr5e00VxCU',
  },
};
